import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { RouterProvider } from "react-router/dom";

import { createQueryClient } from "@/api/query-client";
import { ConfirmProvider } from "@/components/ui/confirm";
import { SessionProvider } from "@/auth/session";
import { BranchProvider } from "@/branch/provider";
import { I18nProvider } from "@/i18n/provider";
import { ThemeProvider } from "@/theme/provider";
import { createAppRouter } from "./active-router";

/**
 * The providers, in order (guide 4.2). Each one needs the ones above it:
 * the theme before anything is drawn, words before any message, server data
 * before the session, the session before the branch.
 */
export function App() {
  const [queryClient] = useState(createQueryClient);
  // DukaanBook has its own pages; the providers around them are shared.
  const [router] = useState(createAppRouter);

  return (
    <ThemeProvider>
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <SessionProvider>
            {/* Changing branch goes to Home, as on the phone. */}
            <BranchProvider onSwitched={() => void router.navigate("/")}>
              <ConfirmProvider>
                <RouterProvider router={router} />
              </ConfirmProvider>
            </BranchProvider>
          </SessionProvider>
        </QueryClientProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
